const generateRandomNumber = (maxLimit = 100) => Math.floor(Math.random() * maxLimit);

export default generateRandomNumber;
